import { render, staticRenderFns } from "./ActFooter.vue?vue&type=template&id=26e6242d&"
import script from "./ActFooter.vue?vue&type=script&lang=js&"
export * from "./ActFooter.vue?vue&type=script&lang=js&"
import style0 from "./ActFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports